import { ErrorLabel } from '@/atoms/forms/labels';
import { ReactNode } from 'react';
import { useController, useFormContext } from 'react-hook-form';

type ChildrenProps = {
  onChange: (t: any) => void;
  onBlur: () => void;
  value: string | number;
};

type HeadlessInputType = {
  children: (prop: ChildrenProps) => ReactNode;
  name: string;
};

const HeadlessInput = ({ children, name }: HeadlessInputType) => {
  const {
    formState: { errors },
    control,
  } = useFormContext();
  const {
    field,
    field: { onChange, onBlur, value: controledValue },
  } = useController({
    name,
    control,
  });
  const handleChange = (value: any) => onChange({ target: { name, value } });
  const handleBlur = onBlur;

  return (
    <>
      <input
        // ghost input needed to allow focus on error
        className="opacity-100 h-0"
        {...field}
      />
      {children({ onChange: handleChange, onBlur: handleBlur, value: controledValue })}
      {!!errors[name] && <ErrorLabel error={errors[name]?.message} />}
    </>
  );
};

export default HeadlessInput;
